import { assetUrl } from './assetUrl';
// Older installations keep the banner image outside the banner collection.
export async function loadAdminBanners(baseUrl) {
  const response = await fetch(`${baseUrl}/commercial-banners`, { cache: 'no-store' });
  if (!response.ok) throw new Error('Reklame trenutno nije moguće učitati.');
  const banners = await response.json();
  if (banners.length) return banners;
  const legacyResponse = await fetch(`${baseUrl}/commercial-banner`, { cache: 'no-store' });
  if (!legacyResponse.ok) throw new Error('Postojeću reklamu nije moguće učitati.');
  const legacy = await legacyResponse.json();
  if (!legacy.url) return [];
  const image = await fetch(assetUrl(legacy.url), { method: 'HEAD' });
  if (!image.ok) return [];
  return [legacy];
}
